function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./colors"));
__export(require("./themes"));
__export(require("./typography"));
//# sourceMappingURL=index.js.map